import { appConfig } from "@/app/module_api";

const tag = "[ effects/jitsi.ts ]";
let jitsiMeetApiObject: any = null;
let jitsiScriptElement: HTMLScriptElement | null = null;
let jitsiContainer: HTMLDivElement | null = null;
let callActive = false;
let activeRoomId: string | null = null;

let initialized = false;
export default {
  initialize(config: any) {
    if (initialized) {
      return;
    }
    console.log(tag, "initialize", config);
    window.addEventListener("onConferenceJoined", () => {
      console.log(tag, "onConferenceJoined");
    });
    window.addEventListener("onConferenceTerminated", () => {
      console.log(tag, "onConferenceTerminated");
    });
    window.addEventListener("onConferenceLeft", () => {
      console.log(tag, "onConferenceLeft");
    });
    initialized = true;
  },
  async join({
    roomId,
    token,
    serverUrl,
  }: {
    roomId: string;
    token: string;
    serverUrl?: string | null;
  }) {
    console.log(tag, "join web code running");

    const resolvedJitsiUrl = (serverUrl && serverUrl.trim()) || null;
    if (!resolvedJitsiUrl) {
      console.error(tag, "missing serverUrl from /get-call-token - calls are disabled");
      callActive = false;
      activeRoomId = null;
      return;
    }

    callActive = true;
    activeRoomId = roomId;

    // create jitsi container
    jitsiContainer = document.createElement("div");
    jitsiContainer.id = "jitsi-container";
    document.body.appendChild(jitsiContainer);

    // absolute positioning
    jitsiContainer.style.position = "absolute";
    jitsiContainer.style.top = "0";
    jitsiContainer.style.zIndex = "999999";

    // load script programatically
    const jitsiUrl = resolvedJitsiUrl.replace(/\/+$/, "");
    jitsiScriptElement = document.createElement("script");
    jitsiScriptElement.src = jitsiUrl + "/external_api.js";

    // iframe sdk
    const domain = jitsiUrl.split("//")[1];
    const options = {
      roomName: roomId,
      // full screen
      width: "100vw",
      height: "100vh",
      parentNode: document.querySelector("#jitsi-container"),
      jwt: token,
      prejoinConfig: {
        enabled: false,
      },
      configOverwrite: {
        disableDeepLinking: true,
        startWithAudioMuted: false,
        startWithVideoMuted: true,
        // onprem1 currently serves BOSH reliably; websocket upgrade is not available.
        preferBosh: true,
        websocket: "",
        bosh: `${jitsiUrl}/http-bind`,
        p2p: {
          enabled: true,
        },
        stunServers: appConfig.stunServers,
        prejoinPageEnabled: false,
      },
      interfaceConfigOverwrite: {
        APP_NAME: "Meet",
        MOBILE_APP_PROMO: false,
        SHOW_BRAND_WATERMARK: false,
        SHOW_JITSI_WATERMARK: false,
        SHOW_WATERMARK_FOR_GUESTS: false,
        SHOW_POWERED_BY: false,
      },
    };

    jitsiScriptElement.onload = () => {
      console.log(tag, "script loaded");
      // @ts-ignore
      jitsiMeetApiObject = new JitsiMeetExternalAPI(domain, options);
      jitsiMeetApiObject.on("readyToClose", () => {
        console.log(tag, "readyToClose");
        jitsiMeetApiObject.dispose();
        if (jitsiContainer && jitsiContainer.parentNode) {
          jitsiContainer.parentNode.removeChild(jitsiContainer);
        }
        if (jitsiScriptElement && jitsiScriptElement.parentNode) {
          jitsiScriptElement.parentNode.removeChild(jitsiScriptElement);
        }
        jitsiContainer = null;
        jitsiScriptElement = null;
        jitsiMeetApiObject = null;
        callActive = false;
        activeRoomId = null;
      });
    };
    jitsiScriptElement.onerror = () => {
      console.error(tag, "failed to load external_api.js");
      callActive = false;
      activeRoomId = null;
    };

    document.body.appendChild(jitsiScriptElement);
  },
  getStatus() {
    return {
      callActive,
      roomId: activeRoomId,
    };
  },
  async leave() {
    try {
      if (jitsiMeetApiObject) {
        jitsiMeetApiObject.dispose();
      }
    } finally {
      if (jitsiContainer && jitsiContainer.parentNode) {
        jitsiContainer.parentNode.removeChild(jitsiContainer);
      }
      if (jitsiScriptElement && jitsiScriptElement.parentNode) {
        jitsiScriptElement.parentNode.removeChild(jitsiScriptElement);
      }
      jitsiContainer = null;
      jitsiScriptElement = null;
      jitsiMeetApiObject = null;
      callActive = false;
      activeRoomId = null;
    }
  },
};
